import { CdkMenuModule } from '@angular/cdk/menu';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { Credenciais } from 'src/app/models/credenciais.model';
import { ApiCotacoesService } from 'src/app/services/api-cotacoes.service';
import { ApiApiceService } from 'src/app/services/api/api-apice.service';
import { ControllerStatusService } from 'src/app/services/controller-status.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MAPA_SEGURADORAS } from 'src/app/constants/mapa-seguradoras.constant';
import { IntegracaoConstants } from 'src/app/constants/integracao';

@Component({
  selector: 'app-menu-seguradoras',
  standalone: true,
  imports: [CdkMenuModule, MatTooltip, MatProgressSpinner],
  templateUrl: './menu-seguradoras.component.html',
  styleUrls: ['./menu-seguradoras.component.scss'],
})
export class MenuSeguradorasComponent implements OnInit {
  private apiCotacao = inject(ApiCotacoesService);
  private api = inject(ApiApiceService);
  private utilsService = inject(UtilsService);
  private controllerStatusService = inject(ControllerStatusService);

  private seguradoras = IntegracaoConstants.seguradoras;

  protected carregandoAcesso = signal(false);
  protected carregandoSeguradoras = signal(true);

  protected confsSeguradoras = signal<any[]>([]);
  protected confsSeguradorasInvalidas = signal<any[]>([]);

  private readonly seguradorasRemovidas = [
    this.seguradoras.SOMPO.id,
    this.seguradoras.AKAD.id,
    this.seguradoras.ALFA.id,
    this.seguradoras.CAPEMISA.id,
  ];

  ngOnInit(): void {
    this.loadSeguradoras();
  }

  private async loadSeguradoras() {
    this.carregandoSeguradoras.set(true);
    if (this.controllerStatusService.confsSeguradoras.length === 0) {
      await this.controllerStatusService.buscaSeguradoras();
    }

    let confs = this.controllerStatusService.confsSeguradoras;
    let confsInv = this.controllerStatusService.confsSeguradorasInv;

    this.sortSeguradoras(confs);
    this.sortSeguradoras(confsInv);

    confs = this.removeSeguradoras(confs);
    confsInv = this.removeSeguradoras(confsInv);

    this.atribuiCaminhoIcone(confs);
    this.atribuiCaminhoIcone(confsInv);

    this.confsSeguradoras.set(confs);
    this.confsSeguradorasInvalidas.set(confsInv);
    this.carregandoSeguradoras.set(false);
  }

  private sortSeguradoras = (seguradoras: any[]): void => {
    seguradoras.sort((a, b) =>
      a.dados.nomeSeguradora.localeCompare(b.dados.nomeSeguradora)
    );
  };

  private removeSeguradoras(seguradoras: any[]) {
    const seen = new Set();

    return seguradoras.filter((x) => {
      const seguradora = x?.dados?.seguradora;

      if (
        this.seguradorasRemovidas.includes(seguradora) ||
        seen.has(seguradora)
      ) {
        return false;
      }

      seen.add(seguradora);
      return true;
    });
  }

  private atribuiCaminhoIcone(lista: any[]) {
    lista.forEach((objeto) => {
      const nomePadronizado = objeto.dados.nomeSeguradora
        .toLowerCase()
        .replace(/\s/g, '')
        .replace(/(^|_)(\w)/g, (_, __, c) => c.toUpperCase());

      const nomeIcone =
        MAPA_SEGURADORAS[nomePadronizado.toLowerCase()] || nomePadronizado;

      objeto.imgIcone = `https://img.agger.com.br/assets/seguradoras/${nomeIcone}.png`;
    });
  }

  protected async acessaSeguradora(idIntegracao) {
    this.carregandoAcesso.set(true);
    try {
      let credenciais: Credenciais | any = await this.api.getCfgSeg(
        idIntegracao
      );
      await this.apiCotacao.logarSeguradora(credenciais);
    } catch (error) {
      this.utilsService.alertCustom({
        txt: 'Falha ao buscar seguradora, tente novamente!',
        alertType: 'ERROR',
        duration: 4000,
      });
    } finally {
      this.carregandoAcesso.set(false);
    }
  }
}
